import {
  NavigateFunction,
  Outlet,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "./App.css";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import {
  Box,
  CssBaseline,
  ThemeProvider,
  createTheme,
  PaletteMode,
  Button,
} from "@mui/material";
import React from "react";
import LightModeSwitch from "./components/LightModeSwitch/LightModeSwitch";
import ColorLightMode from "./CustomColor/ColorLightMode";
import { Context } from "./Context";
import PageURL from "./PageURL";
import StickyProfilePicture from "./components/StickyPicture/StickyProfilePicture";

function App() {
  const [mode, setMode] = React.useState<PaletteMode>("light");
  const [pageIndex, setPageIndex] = React.useState(-1);
  const { pathname } = useLocation();
  const nav = useNavigate();
  React.useEffect(() => {
    determinePage(nav, setPageIndex, pathname);
  });

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  React.useEffect(() => {
    document.getElementById("body")!.style.backgroundColor =
      mode !== "dark" ? "#e5e8da" : "gray";
  }, [mode]);
  const context = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
      pageIndex: pageIndex,
      setPageChange: (index: number) => {
        setPageIndex(index);
      },
    }),
    [pageIndex]
  );
  const theme = React.useMemo(() => createTheme(ColorLightMode(mode)), [mode]);

  return (
    <Context.Provider value={context}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div id="App">
          <Box
            className="container"
            sx={{
              color: "text.primary",
              backgroundColor: "background.default",
            }}
          >
            <Header />
            <StickyProfilePicture />
            <Outlet />
            <br />
            <Footer />
            <LightModeSwitch />
          </Box>
        </div>
      </ThemeProvider>
    </Context.Provider>
  );
}
function determinePage(
  nav: NavigateFunction,
  setPageIndex: (value: React.SetStateAction<number>) => void,
  pathname: string
) {
  let index = -1;
  for (let i = 0; i < PageURL.length; i++) {
    const { url } = PageURL[i];
    if (pathname.includes(url)) {
      index = i;
      setPageIndex(i);
      break;
    }
  }
  if (index === -1) {
    nav("/home");
    setPageIndex(0);
  }
}
export default App;
